<template>
  <!-- PAGE LOADER -->
  <div id="page-loader">
    <!-- CONTAINER MID -->
    <div class="container-mid">
      <img
        src="@/assets/img/edgefirst_hexagon_light.svg"
        class="img-responsive"
        width="300px"
        alt="image"
      >

      <!-- SPINNER CONTAINER -->
      <div class="spinner-container">
        <div class="css-spinner" />
      </div>
      <!-- /SPINNER CONTAINER -->
    </div>
    <!-- /CONTAINER MID -->
  </div>
  <!-- /PAGE LOADER -->

  <!-- NAVIGATION -->

  <nav class="navigation-main sticky-navigation is-sticky">
    <!-- CONTAINER -->
    <a href="#">
      <img class="image-top" src="@/assets/img/logo-white.svg" width="160px" ></a>
    <div class="container">
      <!-- NAVIGATION HEADER -->
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle"
          data-toggle="collapse"
          data-target="#navbar"
          @click="handleMenuClick"
        >
          <span class="ti-menu" />
        </button>
      </div>
      <!-- /NAVIGATION HEADER -->

      <!-- NAVBAR -->
      <div id="navbar" class="navbar-collapse collapse">
        <!-- MENU ITEMS LIST -->
        <ul class="navigation-items nav navbar-nav navbar-right">
          <li> <a class="phantom" href="#hero">Home</a> </li>
          <!-- <li> <a @click="handleScrollToSection('features')">Features</a> </li> -->
          <li> <a @click="handleScrollToSection('workflow')">Workflows</a> </li>
          <li> <a @click="handleScrollToSection('agtg')">Features</a> </li>
          <li> <a @click="handleScrollToSection('testimonials')">Testimonials</a> </li>
             <li> <a @click="handlePricing('price')">Pricing</a> </li>
          <li> <a @click="handleScrollToSection('contact')">Contact Us</a> </li>
          <li> <a :href="helpUrl">Documentation</a> </li>
          <li />
          <li> <router-link id="login-btn" class="button button-secondary login-btn" to="/login">Login</router-link> </li>
          <li>
            <a
              id="get-started-btn"
              class="button login-btn"
              @click="handleStartForFree"
            >Start for free</a>
          </li>
        </ul>
      </div>
      <!-- /NAVBAR -->
    </div>
    <!-- /CONTAINER -->
  </nav>
  <!-- /NAVIGATION -->



  <div id="main" class="dve-landing">

    <!-- HERO -->
    <section id="hero" class="hero">
      <!-- FRONT CONTENT -->
      <div class="front-content">
        <div class="inner-header">
            <h1 id="hero-h1">Full 3D AI Perception Toolset</h1>
              <p id="hero-h1">From images to edge deployment in a few clicks.</p>
              <p id="hero-h1">EdgeFirst Studio supports a wide variety of models for any vision tasks.</p>
            <br>
        </div>
        
      </div>
      <!-- /FRONT CONTENT -->

      <!-- BACKGROUND CONTENT -->
      <div class="background-content page-enter-animated">
        <div class="image-backdrop" />
        <!-- LEVEL 1 -->
        <div class="level-1">
          <template v-for="(image, index) in heroImages">
            <transition name="slide-fade">
              <img
                v-if="heroImage === index"
                :key="index"
                :src="image"
                class="level-1-img"
              >
            </transition>
          </template>
        </div>
        <!-- /LEVEL 1 -->

        <!-- /LEVEL 2 -->
      </div>
      <!-- /BACKGROUND CONTENT -->
    </section>
    <!-- /HERO -->
    <!-- <header class="header">
      <div class="nav-group">
        <img class="header__logo" :src="require('@/assets/img/auzoneLogo.svg')" alt="">
        <span @click="navigateToMain">Deep View Enterprise</span>
        <span @click="navigateToPricing">Pricing</span>
        <span @click="navigateToHelp">Help</span>
      </div>
    </header> -->

    <!-- MLOPS -->
    <section id="workflow" ref="workflow">
      <!-- CONTENT -->
      <div class="content bg-white block-service-1 padding-top-100">
        <!-- CONTAINER -->
        <div class="container">
          <!-- HEADER -->
          <!-- <div class="header text-center">
            <h2>Workflow</h2>
          </div> -->
          <!-- /HEADER -->
          <template v-if="!shouldDisplayCarousel">
            <!-- TAB NAVIGATION -->
            <ul class="tab-navigation ">
              <!-- ITEM -->
              <li class="scroll-animated-from-bottom mouse-hover" :class="{active: mlopsTab === 'dataset-curation'}">
                <!-- TAB LINK -->
                <a data-toggle="tab" @click="handleWorkflowTab('dataset-curation')">
                  <div class="workflow-icon-container mb-3 no-border">
                    <SVGIcon
                      :iconName="'database'"
                      :width="'56px'"
                      :height="'56px'"
                    />
                  </div>
                  Data Curation

                </a>
              <!-- /TAB LINK -->
              </li>
              <!-- /ITEM -->
              <div class="chevron-container">
                <SVGIcon
                  :iconName="'chevron_right'"
                  :width="'20px'"
                  :height="'20px'"
                />
              </div>
              <!-- ITEM -->
              <li class="scroll-animated-from-bottom  mouse-hover" :class="{active: mlopsTab === 'annotation'}">
                <!-- TAB LINK -->
                <a data-toggle="tab" @click="handleWorkflowTab('annotation')">

                  <div class="workflow-icon-container mb-3 no-border">
                    <SVGIcon
                      :iconName="'bounding-box'"
                      :width="'56px'"
                      :height="'56px'"
                    />
                  </div>
                  Annotation
                </a>
              <!-- /TAB LINK -->
              </li>
              <!-- /ITEM -->
              <div class="chevron-container">
                <SVGIcon
                  :iconName="'chevron_right'"
                  :width="'20px'"
                  :height="'20px'"
                />
              </div>
              <!-- ITEM -->
              <li class="scroll-animated-from-bottom  mouse-hover" :class="{active: mlopsTab === 'training'}">
                <!-- TAB LINK -->
                <a data-toggle="tab" @click="handleWorkflowTab('training')">

                  <div class="workflow-icon-container mb-3 no-border">
                    <SVGIcon
                      :iconName="'train'"
                      :width="'56px'"
                      :height="'56px'"
                    />
                  </div>
                  Training
                </a>
              <!-- /TAB LINK -->
              </li>
              <!-- /ITEM -->
              <div class="chevron-container">
                <SVGIcon
                  :iconName="'chevron_right'"
                  :width="'20px'"
                  :height="'20px'"
                />
              </div>
              <!-- ITEM -->
              <li class="scroll-animated-from-bottom  mouse-hover" :class="{active: mlopsTab === 'validation'}">
                <!-- TAB LINK -->
                <a data-toggle="tab" @click="handleWorkflowTab('validation')">

                  <div class="workflow-icon-container mb-3 no-border">
                    <SVGIcon
                      :iconName="'chart_bar_stacked'"
                      :width="'56px'"
                      :height="'56px'"
                    />
                  </div>
                  Validation
                </a>
              <!-- /TAB LINK -->
              </li>
              <!-- /ITEM -->
              <div class="chevron-container">
                <SVGIcon
                  :iconName="'chevron_right'"
                  :width="'20px'"
                  :height="'20px'"
                />
              </div>
              <!-- ITEM -->
              <li class="scroll-animated-from-bottom  mouse-hover" :class="{active: mlopsTab === 'edge-deployment'}">
                <!-- TAB LINK -->
                <a data-toggle="tab" @click="handleWorkflowTab('edge-deployment')">

                  <div class="workflow-icon-container mb-3 no-border">
                    <SVGIcon
                      :iconName="'chip'"
                      :width="'56px'"
                      :height="'56px'"
                    />
                  </div>
                  Deployment

                </a>
              <!-- /TAB LINK -->
              </li>
            <!-- /ITEM -->
            </ul>
            <!-- /TAB NAVIGATION -->

            <!-- TAB CONTENT CONTAINER -->
            <div class="tab-content mt-5 scroll-animated-from-bottom">
              <!-- TAB CONTENT 1 -->
              <div v-if="mlopsTab === 'dataset-curation'" id="dataset-curation" class="tab-pane fade in active">
                <!-- ROW -->
                <div class="row">
                  <!-- COLUMN -->
                  <div class="col-sm-6 mb-5">
                    <div class="dosis-font" style="font-size: 1.2em;">
                      EdgeFirst Studio provides pipelines for uploading and processing datasets using EdgeFirst Dataset, Darknet, and YOLO formats.
                      Each dataset contains multiple annotation sets, where users can create different annotations for an image and select each set for model experiments.
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <img class="workflow-image" src="@/assets/landing-page/assets/images/features/coco128dataset.png">
                  </div>
                </div>
              <!-- /ROW -->
              </div>
              <!-- /TAB CONTENT 1 -->

              <!-- TAB CONTENT 2 -->
              <div v-if="mlopsTab === 'annotation'" id="annotation" class="tab-pane fade">
                <!-- ROW -->
                <div class="row">
                  <div class="col-sm-6 mb-5">
                    <div class="dosis-font" style="font-size: 1.2em;">
                      Annotations can be imported, manually added, or generated by EdgeFirst Studio AI tools. Visualize and edit 2D and 3D annotations either directly through
                      the editor mode or through a formal auditing process. EdgeFirst Studio provides easy to use tools to help users build their first vision dataset or handle
                      complex vision problems.
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <img class="workflow-image" src="@/assets/landing-page/assets/images/features/3dlabeling.png">
                  </div>
                </div>
              <!-- /ROW -->
              </div>
              <!-- /TAB CONTENT 2 -->

              <!-- TAB CONTENT 3 -->
              <div v-if="mlopsTab === 'training'" id="training" class="tab-pane fade">
                <div class="row">
                  <div class="col-sm-6 mb-5">
                    <div class="dosis-font" style="font-size: 1.2em;">
                      EdgeFirst Studio provide flexible GPU-based training configurations for a wide variety of models.
                      Users can go from dataset to finished model in a few clicks using our proprietary
                      ModelPack or EdgeFirst Fusion models designed for any task. EdgeFirst Studio also support custom models for Enterprise users.
                    </div>
                    <br>
                    <div class="clickable-text" @click="handleScrollToSection('contact')">Contact us to learn more</div>
                  </div>
                  <div class="col-sm-6">
                    <img class="workflow-image" src="@/assets/landing-page/assets/images/features/loss.png">
                  </div>
                </div>
              </div>
              <div v-if="mlopsTab === 'validation'" id="validation" class="tab-pane fade">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="dosis-font" style="font-size: 1.2em;">
                      Validate trained models and compare results from different experiments.
                      Our validation dashboard helps you detect anomalies, monitor performance, and build the best vision models.
                      EdgeFirst Studio offers validation against configurable settings to test your model in many situations.
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <img class="workflow-image" src="@/assets/landing-page/assets/images/features/val2.png">
                  </div>
                </div>
              </div>
              <!-- /TAB CONTENT 4 -->

              <!-- TAB CONTENT 5 -->
              <div v-if="mlopsTab === 'edge-deployment'" id="edge-deployment" class="tab-pane fade">
                <div class="row">
                  <div class="col-sm-6 mb-5">
                    <div class="dosis-font" style="font-size: 1.2em;">
                      Deploy your model to multiple target devices in a few clicks and see it in action. EdgeFirst Studio provides compatibility optimization so your model runs smoothly.
                      We have native support for many devices:
                    </div>
                    <br>
                    <div class="devices-container">
                      <div v-for="d in devices" :key="d.name" class="device">
                        <SVGIcon
                          :iconName="'check_circle'"
                          :width="'22px'"
                          :height="'22px'"
                          class="icon-primary"
                        />
                        <span @click="open(d.link)">{{ d.name }}</span>
                        <!-- <span class="device-link" @click="open(d.link)">{{ d.name }}</span> -->
                      </div>
                    </div>
                    <br>

                    <div class="clickable-text">
                    <a  style="color: inherit;" href="https://doc.edgefirst.ai/latest/getting_started/deploy_model/">Click here to get help on  deployment to target device.</a>
                    </div>
                    <div class="clickable-text" @click="handleScrollToSection('contact')">Don't see your device</div>

                    
                   
                  </div>
                  <div class="col-sm-6">
                    <img class="workflow-image" src="@/assets/landing-page/assets/images/features/deployedCam_large.png">
                  </div>
                </div>
              <!-- /ROW -->
              </div>
            <!-- /TAB CONTENT 5 -->
            </div>
          </template>
          <template v-else>
            <v-carousel
              height="800"
              :show-arrows="hover"
              cycle
              hide-delimiters
            >
              <v-carousel-item>
                <div class="row">
                  <div class="col-sm-6 mb-5">
                    <div class="d-flex align-items-center">
                      <SVGIcon
                        :iconName="'database'"
                        :width="'40px'"
                        :height="'40px'"
                        class="icon-primary"
                      />
                      <h3>Data Curation</h3>
                    </div>
                    <br>
                    <div class="dosis-font" style="font-size: 1.2em;">
                      EdgeFirst Studio provides pipelines for uploading and processing datasets using EdgeFirst Dataset, Darknet, and YOLO formats.
                      Each dataset contains multiple annotation sets, where users can create different annotations for an image and select each set for model experiments.
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <img class="workflow-image" src="@/assets/landing-page/assets/images/features/coco128dataset.png">
                  </div>
                </div>
              </v-carousel-item>
              <v-carousel-item>
                <div class="row">
                  <div class="col-sm-6 mb-5">
                    <div class="d-flex align-items-center">
                      <SVGIcon
                        :iconName="'bounding-box'"
                        :width="'40px'"
                        :height="'40px'"
                        class="icon-primary"
                      />
                      <h3>Annotation</h3>
                    </div>
                    <br>
                    <div class="dosis-font" style="font-size: 1.2em;">
                      Annotations can be imported, manually added, or generated by EdgeFirst Studio AI tools. Visualize and edit 2D and 3D annotations either directly through
                      the editor mode or through a formal auditing process. EdgeFirst Studio provides easy to use tools to help users build their first vision dataset or handle
                      complex vision problems.
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <img class="workflow-image" src="@/assets/landing-page/assets/images/features/3dlabeling.png">
                  </div>
                </div>
              </v-carousel-item>
              <v-carousel-item>
                <div class="row">
                  <div class="col-sm-6 mb-5">
                    <div class="d-flex align-items-center">
                      <SVGIcon
                        :iconName="'train'"
                        :width="'40px'"
                        :height="'40px'"
                        class="icon-primary"
                      />
                      <h3>Training</h3>
                    </div>
                    <br>
                    <div class="dosis-font" style="font-size: 1.2em;">
                      EdgeFirst Studio provides flexible GPU-based training configurations for a wide variety of models.
                      Users can go from dataset to finished model in a few clicks using our proprietary
                      ModelPack or EdgeFirst Fusion models designed for any task. EdgeFirst Studio also support custom models for Enterprise users.
                    </div>
                    <br>
                    <div class="clickable-text" @click="handleScrollToSection('contact')">Contact us to learn more</div>
                  </div>
                  <div class="col-sm-6">
                    <img class="workflow-image" src="@/assets/landing-page/assets/images/features/loss.png">
                  </div>
                </div>
              </v-carousel-item>
              <v-carousel-item>
                <div class="row">
                  <div class="col-sm-6 mb-5">
                    <div class="d-flex align-items-center">
                      <SVGIcon
                        :iconName="'chart_bar_stacked'"
                        :width="'40px'"
                        :height="'40px'"
                        class="icon-primary"
                      />
                      <h3>Validation</h3>
                    </div>
                    <br>
                    <div class="dosis-font" style="font-size: 1.2em;">
                      Validate trained models and compare results from different experiments.
                      Our validation dashboard helps you detect anomalies, monitor performance, and build the best vision models.
                      EdgeFirst Studio offers validation against configurable settings to test your model in many situations.
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <img class="workflow-image" src="@/assets/landing-page/assets/images/features/val2.png">
                  </div>
                </div>
              </v-carousel-item>
              <v-carousel-item>
                <div class="row">
                  <div class="col-sm-6 mb-5">
                    <div class="d-flex align-items-center">
                      <SVGIcon
                        :iconName="'chip'"
                        :width="'40px'"
                        :height="'40px'"
                        class="icon-primary"
                      />
                      <h3>Deployment</h3>
                    </div>
                    <br>
                    <div class="dosis-font" style="font-size: 1.2em;">
                      Deploy your model to multiple target devices in a few clicks and see it in action. EdgeFirst Studio provides compatibility optimization so your model runs smoothly.
                      We have native support for many devices:
                    </div>
                    <br>
                    <div class="devices-container">
                      <div v-for="d in devices" :key="d.name" class="device">
                        <SVGIcon
                          :iconName="'check_circle'"
                          :width="'22px'"
                          :height="'22px'"
                          class="icon-primary"
                        />
                        <span @click="open(d.link)">{{ d.name }}</span>
                        <!-- <span class="device-link" @click="open(d.link)">{{ d.name }}</span> -->
                      </div>
                    </div>
                    <br>
                    <div class="clickable-text" @click="handleScrollToSection('contact')">Add your own device</div>
                    <a href="https://doc.edgefirst.ai/latest/getting_started/deploy_model/">Click here to get help on  deployment to target device.</a>
                  </div>
                  <div class="col-sm-6">
                    <img class="workflow-image" src="@/assets/landing-page/assets/images/features/deployedCam_large.png">
                  </div>
                </div>
              </v-carousel-item>
            </v-carousel>
          </template>
          <!-- /TAB CONTENT CONTAINER -->
        </div>
      </div>
      <!-- /CONTENT -->
    </section>
    <!-- /MLOPS -->

    <!-- AGTG -->
    <section id="agtg" ref="agtg">
      <!-- CONTENT -->
      <div class="content bg-white block-about-1 padding-top-100">
        <!-- CONTAINER -->
        <div class="container text-left">
          <div class="header text-center">
            <h2>Features</h2>
          </div>
          <!-- ROW -->
          <div class="row padding-top-50">
            <div class="col-sm-6 mb-5" style="font-size: 1.2em;">
              <h3>Auto-labelling</h3>
              <br>
              <div class="dosis-font">Rapidly import data as video, frame sequences, MCAP, or other popular formats getting instant Ground Truth.</div>
              <div class="dosis-font">
                EdgeFirst Studio Automated Ground Truth Generation feature uses AI and machine learning algorithms to
                produce 2D and 3D bounding boxes and segmentation masks with ease.
              </div>
            </div>
            <div class="col-sm-6">
              <img class="img-responsive scroll-animated-from-bottom" src="@/assets/landing-page/assets/videos/label.gif">
            </div>
          </div>
          <div class="row padding-top-50 reverse-on-mobile">
            <div class="col-sm-6">
              <img class="img-responsive scroll-animated-from-bottom" src="@/assets/landing-page/assets/videos/annotatedCar.gif">
            </div>
            <div class="col-sm-6 mb-5" style="font-size: 1.2em;">
              <h3>3D Perception and Physical AI</h3>

              <br>
              <div class="dosis-font">Built-in support for 3D data and sensors such as LiDAR, RADAR, Point Cloud, Depth Maps, and more.</div>
              <br>
              <div class="dosis-font">EdgeFirst Studio allows you to quickly make edits using the editor tool. Teams can create formal auditing processes to ensure data security.</div>
            </div>
          </div>
          <div class="row padding-top-50">
            <div class="col-sm-6 mb-5" style="font-size: 1.2em;">
              <h3>Optimize Models</h3>
              <br>
              <div class="dosis-font">
                Train models with Radar and Vision data using our EdgeFirst Fusion model.
              </div>
              <br>
              <div class="dosis-font">
                EdgeFirst Studio allows users to train multiple models in parallel and compare experiments. Evaluate training sessions after each run to see how your dataset impacts performance.
              </div>
            </div>
            <div class="col-sm-6">
              <img class="img-responsive scroll-animated-from-bottom" src="@/assets/landing-page/assets/videos/lidar_short.gif">
            </div>
          </div>

          <!-- ROW -->
        </div>

        <!-- /CONTAINER -->
      </div>
      <!-- /CONTENT -->
    </section>
    <!-- /AGTG -->

    <!-- Testimonials -->
    <section id="testimonials" ref="testimonials">
      <!-- CONTENT -->
      <div class="content bg-white block-team-1 padding-top-100">
        <!-- CONTAINER -->
        <div class="container">
          <!-- HEADER -->
          <div class="header text-center scroll-animated-from-bottom">
            <h2>Backed by real results</h2>
          </div>

          <!-- /HEADER -->
        </div>
        <!-- /CONTAINER -->

        <!-- CONTAINER   Testimonials  -->

        <div class="container padding-top-10">
          <TestimonialLanding />
        </div>
        <!-- /CONTAINER Testimonials -->
      </div>
      <!-- /CONTENT -->
    </section>
    <!-- /Testimonials -->

    <!-- CONTACT -->
    <section id="contact" ref="contact">
      <!-- CONTENT -->
      <div class="content bg-white block-contact-1 padding-top-100">
        <!-- CONTAINER -->
        <div class="container">
          <!-- HEADER -->
          <div class="header text-center scroll-animated-from-bottom">
            <h2>Contact Us</h2>
          </div>
        <!-- /HEADER -->
        </div>
        <!-- /CONTAINER -->
        <ContactFormLanding />
      </div>
      <!-- /CONTENT -->
    </section>
    <!-- /CONTACT -->

    <!-- FOOTER -->
    <FooterLanding @scroll-to-top="scrollToTop" />
    <!-- /FOOTER -->

    <!-- PHANTOM WRAPPER FOR POPUPS ( REQUIRED FOR POPUPS )-->
    <div class="phantom-wrapper-popups" />
  </div>
</template>

<script setup>
import {
  onMounted, onUnmounted, ref, nextTick, computed,
} from 'vue';
import { useRouter } from 'vue-router';

import { useStore } from 'vuex';
import PricingSection from '@/components/subscription/PricingSection.vue';
import "@/assets/landing-page/assets/css/vegas.css";
import SignupFormLanding from '@/components/SignupFormLanding.vue';
import ContactFormLanding from '@/components/ContactFormLanding.vue';
import FooterLanding from '@/components/FooterLanding.vue';
import TestimonialLanding from '@/components/TestimonialLanding.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import TabsSelector from '@/components/TabsSelector.vue';

const store = useStore();
const navigationFixed = ref(false);
const features = ref(null);
const workflow = ref(null);
const agtg = ref(null);
const edge = ref(null);
const price = ref(null);
const trial = ref(null);
const contact = ref(null);
const testimonials = ref(null);
const router = useRouter();
const sections = {
  features,
  workflow,
  agtg,
  edge,
  price,
  trial,
  contact,
  testimonials,
};
const mlopsTab = ref('dataset-curation');
const width = ref(window.innerWidth);
const planTerms = ref([
  { value: 'month', display: "Monthly" },
  { value: 'year', display: "Annually (save 10%)" },
]);
const planTerm = ref("month");

const workflowList=[
  'dataset-curation',
  'annotation',  
  'training',
  'validation',
  'edge-deployment'
];

var rotateWorkflowIndex=0; 


const devices = ref([
  {
    name: 'Raivin 4D Radar + Vision',
    link: 'https://www.edgefirst.ai/edgefirstmodules#comp-m8x87hpc4',
  },
  {
    name: 'Maivin Vision​',
    link: 'https://www.edgefirst.ai/edgefirstmodules#comp-m8x87hp9',
  },
  {
    name: 'i.MX8M Plus',
    link: 'https://www.nxp.com/products/IMX8MPLUS',
  },
  {
    name: 'i.MX95',
    link: 'https://www.nxp.com/products/i.MX95',
  },
  {
    name: 'NVIDIA Jetson',
    link: 'https://developer.nvidia.com/embedded/jetson-modules',
  },
  {
    name: 'Kinara ARA-2',
    link: 'https://kinara.ai/products/kinara-ara-2/',
  },
]);

const shouldDisplayCarousel = computed(() => width.value < 576);

const helpUrl = computed(() => {
  let domainPrefix = "https://doc.edgefirst.ai/";

  if (window.location.host.includes('localhost', 0)) domainPrefix = "https://doc.edgefirst.ai/test/";
  if (window.location.host.includes('test', 0)) domainPrefix = "https://doc.edgefirst.ai/test/";
  if (window.location.host.includes('stage', 0)) domainPrefix = "https://doc.edgefirst.ai/stage/";
  if (window.location.host.includes('dev', 0)) domainPrefix = "https://doc.edgefirst.ai/test/";

  return domainPrefix;
});

// Define all config variables globally
window.option_hero_animate_content_on_scroll = "on";
window.option_hero_3d_hover_effect = "on";
window.option_hero_parallax_hover_effect = "on";
window.option_hero_gravity_effect = "on";
window.option_hero_background_mode = "kenburns";

// Image background config
window.option_hero_background_image_path = [{ src: '/landing-page/assets/images/1.jpg' }];

// Slider background config
window.option_hero_background_slider_path = [{ src: "/landing-page/assets/images/1.jpg" }, { src: "/landing-page/assets/images/2.jpg" }, { src: "/landing-page/assets/images/3.jpg" }];
window.option_hero_background_slider_delay = 6000;
window.option_hero_background_slider_transition = "slideDown";
window.option_hero_background_slider_transitionDuration = 800;

// Kenburns background config
window.option_hero_background_kenburns_path = [{ src: "/landing-page/assets/images/1.jpg" }, { src: "/landing-page/assets/images/2.jpg" }, { src: "/landing-page/assets/images/3.jpg" }];
window.option_hero_background_kenburns_delay = 6000;
window.option_hero_background_kenburns_transition = "slideDown";
window.option_hero_background_kenburns_transitionDuration = 800;

// Add any other config variables needed by your scripts
window.option_analytics_tracking = "off";
window.option_analytics_tracking_id = "UA-XXXXXXXX-X";

const heroImage = ref(0);
const heroImages = ref([]);

function changeImage() {
  heroImage.value = (heroImage.value + 1) % heroImages.value.length;
}

onMounted(() => {
  const navbarToggle = document.querySelector(".navbar-toggle");
  const navbarCollapse = document.querySelector(".navbar-collapse");

  if (navbarToggle && navbarCollapse) {
    // Close the navbar when clicking outside
    document.addEventListener("click", handleMenuClickOutside);
  }

  window.addEventListener('resize', handleResize);

  store.commit('setTheme', "theme-auzone-light");

  navigationFixed.value = false;

  loadScripts();
});

onUnmounted(() => {
  document.removeEventListener("click", handleMenuClickOutside);
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  width.value = window.innerWidth;
}

function planClickedHandler(plan_name) {
  if (plan_name === "free") {
    router.push({ path: '/signup' });
  }
  if (plan_name === "team") {
    router.push({ path: '/signup' });
  }
  if (plan_name === "business") {
    router.push({ path: '/signup' });
  }
  if (plan_name === "custom") {
    handleScrollToSection("contact");
  }
}

function handleStartForFree() {
  router.push({ path: '/signup' });
}
function handlePricing() {
  router.push({ path: '/price' });
}

async function handleMenuClick() {
  const navbarToggle = document.querySelector(".navbar-toggle");
  const navbarCollapse = document.querySelector(".navbar-collapse");
  const navbarMain = document.querySelector(".navigation-main");
  const isExpanded = navbarCollapse.classList.toggle("in"); // Toggle class
  navbarMain.classList.toggle("in"); // Toggle class
  navbarToggle.setAttribute("aria-expanded", isExpanded);
}

async function handleMenuClickOutside(event) {
  const navbarToggle = document.querySelector(".navbar-toggle");
  const navbarCollapse = document.querySelector(".navbar-collapse");
  const navbarMain = document.querySelector(".navigation-main");
  if (!navbarCollapse.contains(event.target) && !navbarToggle.contains(event.target)) {
    navbarCollapse.classList.remove("in");
    navbarMain.classList.remove("in"); // Toggle class
    navbarToggle.setAttribute("aria-expanded", "false");
  }
}

async function handleScrollToSection(section) {
  await nextTick(); // Ensure elements are ready

  if (sections[section]) {
    sections[section].value.scrollIntoView({ behavior: 'smooth' });
  }
}

function scrollToTop() {
  const scrollableElement = document.querySelector("#main");
  scrollableElement.scrollTo({ top: 0, behavior: "smooth" });
}

function rotateWorkflows() {
  if (rotateWorkflowIndex<0) return; 
  if (rotateWorkflowIndex>=workflowList.length) rotateWorkflowIndex=0
  
  mlopsTab.value = workflowList[rotateWorkflowIndex];
  rotateWorkflowIndex++;
}

function loadScripts() {
  document.getElementById('page-loader').classList.add('hide-this');

  setInterval(() => {
    rotateWorkflows();
  }, 3000);
}

function handleWorkflowTab(tab) {
  rotateWorkflowIndex=-1;
  mlopsTab.value = tab;
}

function open(link) {
  window.open(link);
}

</script>

<style lang="css" scoped src="@/assets/landing-page/assets/css/icons.css"></style>
<style lang="css" scoped src="@/assets/landing-page/assets/css/layout.css"></style>
<style lang="scss" scoped src="@/assets/landing-page/assets/css/hero.scss"></style>
<style lang="css" scoped src="@/assets/landing-page/assets/css/blocks.css"></style>
<style lang="scss" scoped>




@media (max-width: 600px) {
  #hero h1 {
    font-size: 20px;
    margin-right: 20px;
  }
}
@media (max-width: 600px) {
  #hero p {
    font-size: 12px;
    margin-right: 20px;
  }
}

.no-border  {
  border:none !important;
  border-radius: 0;

}
.no-border  :hover {
  border:none !important;
   border-radius: 0 !important;
}


.mouse-hover  {
  border-radius: 10px;
  padding:10px;
}

.mouse-hover :hover    {
  background: #e0eafe;
  border-radius: 10px;
  //border: 1px rgb(28, 6, 68) solid;
}


.front-content{
  background-image: url('@/assets/landing-page/assets/images/hexagon_banner.svg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  background-attachment: fixed;
}

.inner-header {
  width: 100%;
  text-align: right;
  margin: 10px;
  margin-right: 20px;
}

li a span {
  font-family: 'themify', sans-serif !important;
}

#main {
  width: 100%;
  height: calc(100vh - 80px);
  font-weight: 300;
  font-style: normal;
  color: #fff;
  background: #111;
  // font-family: 'themify', sans-serif !important;
  overflow: auto;
  font-family: 'Open Sans', sans-serif !important;
  margin-top: 80px;

  --base_color: #1d1631;
  --highlight_color: var(--color-accent);
}

.is-sticky {
  position: fixed !important;
  top: 0 !important;
  width: 100% !important;
  z-index: 1000 !important;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1) !important;
}

#page-loader .spinner-container .css-spinner {
  border-top-color: var(--color-accent) !important;
  border-left-color: var(--color-accent) !important;
}

#popup-close-button-1,.block-about-1 .container-video a span,.block-contact-1
.tab-content .map-wrapper .button-description .content-hidden,.block-contact-1
.tab-content .map-wrapper .button-description .content-visible,.block-contact-1
.tab-content .row .col-xs-4 .container-social-item .container-description,.block-contact-1
.tab-content form .form-group,.block-contact-1 .tab-content form .form-group:after,.block-news-1
.container-news .container-article-info .container-button,.block-process-1 .process-info-box,.block-team-1
.cbp-item .cbp-caption-activeWrap,.block-work-1 .load-more:before,.default-slider
.cbp-nav-pagination-item,.popup-container,.popup-showcase-style-1 .button-description
.content-hidden,.popup-showcase-style-1 .button-description .content-visible,.popup-showcase-style-1
.cbp-nav-pagination-item,.popup-showcase-style-1 .content.bg-gold,.pricing-table-default,a.button-default.inverted:after,
a.button-default:before,ul.tab-navigation-default li.active
{
  background:var(--base_color)  !important
}
.block-contact-1 .tab-content .map-wrapper .container-info ul li a,
.block-contact-1 .tab-content .map-wrapper .container-info ul li h5,
.block-service-1 .tab-navigation li.active a span,.navigation-main ul li
.dropdown-menu a:hover,.navigation-main ul li a:hover,
.navigation-main ul li span:hover,.navigation-main ul li.current a,
.navigation-main ul li.dropdown.open span,.popup-showcase-style-1
.container-info ul li a,.popup-showcase-style-1 .container-info ul li h5
{
  color:var(--highlight_color) !important
}

@media (max-width: 1200px) {
  .navigation-main.in .image-top {
    display: none;
  }
}

.navigation-main ul li .login-btn {
  background-color: var(--color-primary-400) !important;
  color: white;
  padding: 0 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  text-decoration: none;
  line-height: 1 !important;
  height: 40px;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;

  &:hover {
    background-color: var(--color-primary-300);
  }
}

.navigation-main ul li .login-btn.button-secondary {
  background: var(--button-secondary) !important;
  color: var(--button-secondary-text) !important;
  border: solid 2px var(--button-secondary-outlined-border) !important;

  &:hover {
    background: var(--button-secondary-hover-color) !important;
  }
}

#get-started-btn {
  margin-left: 12px;
}

@media (max-width: 1200px) {
  #get-started-btn {
    margin-left: 0px;
  }
}

.cbp img {
  height: 400px;
}

// @media (max-width: $breakpoint-md) {
//   .header {
//     padding: 0;
//     line-height: 1;
//     width: 100%;
//     padding: 0 16px;
//     justify-content: center;
//     align-items: center;
//   }

//   .nav-group {
//     span {
//       padding: 0 10px;
//       font-size: 1.0rem;
//       font-weight: 600;
//       cursor: pointer;
//     }
//   }
// }

$navbar-mobile-breakpoint: 1200px;

.nav {
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}
.nav > li {
    position: relative;
    display: block;
}
.nav > li > a {
    position: relative;
    display: block;
    padding: 10px 15px;
}
.nav > li > a:focus,
.nav > li > a:hover {
    text-decoration: none;
    background-color: #eee;
}
.nav > li.disabled > a {
    color: #777;
}
.nav > li.disabled > a:focus,
.nav > li.disabled > a:hover {
    color: #777;
    text-decoration: none;
    cursor: not-allowed;
    background-color: transparent;
}
.nav .open > a,
.nav .open > a:focus,
.nav .open > a:hover {
    background-color: #eee;
    border-color: #337ab7;
}
.nav .nav-divider {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #e5e5e5;
}
.nav > li > a > img {
    max-width: none;
}
.nav-tabs {
    border-bottom: 1px solid #ddd;
}
.nav-tabs > li {
    float: left;
    margin-bottom: -1px;
}
.nav-tabs > li > a {
    margin-right: 2px;
    line-height: 1.42857143;
    border: 1px solid transparent;
    border-radius: 4px 4px 0 0;
}
.nav-tabs > li > a:hover {
    border-color: #eee #eee #ddd;
}
.nav-tabs > li.active > a,
.nav-tabs > li.active > a:focus,
.nav-tabs > li.active > a:hover {
    color: #555;
    cursor: default;
    background-color: #fff;
    border: 1px solid #ddd;
    border-bottom-color: transparent;
}
.nav-tabs.nav-justified {
    width: 100%;
    border-bottom: 0;
}
.nav-tabs.nav-justified > li {
    float: none;
}
.nav-tabs.nav-justified > li > a {
    margin-bottom: 5px;
    text-align: center;
}
.nav-tabs.nav-justified > .dropdown .dropdown-menu {
    top: auto;
    left: auto;
}
@media (min-width: 1200px) {
    .nav-tabs.nav-justified > li {
        display: table-cell;
        width: 1%;
    }
    .nav-tabs.nav-justified > li > a {
        margin-bottom: 0;
    }
}
.nav-tabs.nav-justified > li > a {
    margin-right: 0;
    border-radius: 4px;
}
.nav-tabs.nav-justified > .active > a,
.nav-tabs.nav-justified > .active > a:focus,
.nav-tabs.nav-justified > .active > a:hover {
    border: 1px solid #ddd;
}
@media (min-width: 1200px) {
    .nav-tabs.nav-justified > li > a {
        border-bottom: 1px solid #ddd;
        border-radius: 4px 4px 0 0;
    }
    .nav-tabs.nav-justified > .active > a,
    .nav-tabs.nav-justified > .active > a:focus,
    .nav-tabs.nav-justified > .active > a:hover {
        border-bottom-color: #fff;
    }
}
.nav-pills > li {
    float: left;
}
.nav-pills > li > a {
    border-radius: 4px;
}
.nav-pills > li + li {
    margin-left: 2px;
}
.nav-pills > li.active > a,
.nav-pills > li.active > a:focus,
.nav-pills > li.active > a:hover {
    color: #fff;
    background-color: #337ab7;
}
.nav-stacked > li {
    float: none;
}
.nav-stacked > li + li {
    margin-top: 2px;
    margin-left: 0;
}
.nav-justified {
    width: 100%;
}
.nav-justified > li {
    float: none;
}
.nav-justified > li > a {
    margin-bottom: 5px;
    text-align: center;
}
.nav-justified > .dropdown .dropdown-menu {
    top: auto;
    left: auto;
}
@media (min-width: 1200px) {
    .nav-justified > li {
        display: table-cell;
        width: 1%;
    }
    .nav-justified > li > a {
        margin-bottom: 0;
    }
}
.nav-tabs-justified {
    border-bottom: 0;
}
.nav-tabs-justified > li > a {
    margin-right: 0;
    border-radius: 4px;
}
.nav-tabs-justified > .active > a,
.nav-tabs-justified > .active > a:focus,
.nav-tabs-justified > .active > a:hover {
    border: 1px solid #ddd;
}
@media (min-width: 1200px) {
    .nav-tabs-justified > li > a {
        border-bottom: 1px solid #ddd;
        border-radius: 4px 4px 0 0;
    }
    .nav-tabs-justified > .active > a,
    .nav-tabs-justified > .active > a:focus,
    .nav-tabs-justified > .active > a:hover {
        border-bottom-color: #fff;
    }
}
.tab-content > .tab-pane {
    // display: none;
}
.tab-content > .active {
    display: block;
}
.nav-tabs .dropdown-menu {
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.navbar {
    position: relative;
    min-height: 50px;
    margin-bottom: 20px;
    border: 1px solid transparent;
}
@media (min-width: 1200px) {
    .navbar {
        border-radius: 4px;
    }
}
@media (min-width: 1200px) {
    .navbar-header {
        float: left;
    }
}
.navbar-collapse {
    padding-right: 15px;
    padding-left: 15px;
    overflow-x: visible;
    -webkit-overflow-scrolling: touch;
    border-top: 1px solid transparent;
    -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
}
.navbar-collapse.in {
    overflow-y: auto;
}
@media (min-width: 1200px) {
    .navbar-collapse {
        width: auto;
        border-top: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .navbar-collapse.collapse {
        display: block !important;
        height: auto !important;
        padding-bottom: 0;
        overflow: visible !important;
    }
    .navbar-collapse.in {
        overflow-y: visible;
    }
    .navbar-fixed-bottom .navbar-collapse,
    .navbar-fixed-top .navbar-collapse,
    .navbar-static-top .navbar-collapse {
        padding-right: 0;
        padding-left: 0;
    }
}
.navbar-fixed-bottom .navbar-collapse,
.navbar-fixed-top .navbar-collapse {
    max-height: 340px;
}
@media (max-device-width: 480px) and (orientation: landscape) {
    .navbar-fixed-bottom .navbar-collapse,
    .navbar-fixed-top .navbar-collapse {
        max-height: 200px;
    }
}
.container-fluid > .navbar-collapse,
.container-fluid > .navbar-header,
.container > .navbar-collapse,
.container > .navbar-header {
    margin-right: -15px;
    margin-left: -15px;
}
@media (min-width: 1200px) {
    .container-fluid > .navbar-collapse,
    .container-fluid > .navbar-header,
    .container > .navbar-collapse,
    .container > .navbar-header {
        margin-right: 0;
        margin-left: 0;
    }
}
.navbar-static-top {
    z-index: 1000;
    border-width: 0 0 1px;
}
@media (min-width: 1200px) {
    .navbar-static-top {
        border-radius: 0;
    }
}
.navbar-fixed-bottom,
.navbar-fixed-top {
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1030;
}
@media (min-width: 1200px) {
    .navbar-fixed-bottom,
    .navbar-fixed-top {
        border-radius: 0;
    }
}
.navbar-fixed-top {
    top: 0;
    border-width: 0 0 1px;
}
.navbar-fixed-bottom {
    bottom: 0;
    margin-bottom: 0;
    border-width: 1px 0 0;
}
.navbar-brand {
    float: left;
    height: 50px;
    padding: 15px 15px;
    font-size: 18px;
    line-height: 20px;
}
.navbar-brand:focus,
.navbar-brand:hover {
    text-decoration: none;
}
.navbar-brand > img {
    display: block;
}
@media (min-width: 1200px) {
    .navbar > .container .navbar-brand,
    .navbar > .container-fluid .navbar-brand {
        margin-left: -15px;
    }
}
@media (max-width: 1400px) {
  .navbar-brand > img {
    width: 150px;
  }
}
.navbar-toggle {
    position: relative;
    float: right;
    padding: 9px 10px;
    margin-top: 8px;
    margin-right: 15px;
    margin-bottom: 8px;
    background-color: transparent;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
}
.navbar-toggle:focus {
    outline: 0;
}
.navbar-toggle .icon-bar {
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px;
}
.navbar-toggle .icon-bar + .icon-bar {
    margin-top: 4px;
}
@media (min-width: 1200px) {
    .navbar-toggle {
        display: none;
    }
}
.navbar-nav {
    margin: 7.5px -15px;
}
.navbar-nav > li > a {
    padding-top: 10px;
    padding-bottom: 10px;
    line-height: 20px;
}
@media (max-width: 767px) {
    .navbar-nav .open .dropdown-menu {
        position: static;
        float: none;
        width: auto;
        margin-top: 0;
        background-color: transparent;
        border: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .navbar-nav .open .dropdown-menu .dropdown-header,
    .navbar-nav .open .dropdown-menu > li > a {
        padding: 5px 15px 5px 25px;
    }
    .navbar-nav .open .dropdown-menu > li > a {
        line-height: 20px;
    }
    .navbar-nav .open .dropdown-menu > li > a:focus,
    .navbar-nav .open .dropdown-menu > li > a:hover {
        background-image: none;
    }
}
@media (min-width: 1200px) {
    .navbar-nav {
        float: left;
        margin: 0;
    }
    .navbar-nav > li {
        float: left;
    }
    .navbar-nav > li > a {
        padding-top: 15px;
        padding-bottom: 15px;
    }
}
.navbar-form {
    padding: 10px 15px;
    margin-top: 8px;
    margin-right: -15px;
    margin-bottom: 8px;
    margin-left: -15px;
    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;
    -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);
}
@media (min-width: 1200px) {
    .navbar-form .form-group {
        display: inline-block;
        margin-bottom: 0;
        vertical-align: middle;
    }
    .navbar-form .form-control {
        display: inline-block;
        width: auto;
        vertical-align: middle;
    }
    .navbar-form .form-control-static {
        display: inline-block;
    }
    .navbar-form .input-group {
        display: inline-table;
        vertical-align: middle;
    }
    .navbar-form .input-group .form-control,
    .navbar-form .input-group .input-group-addon,
    .navbar-form .input-group .input-group-btn {
        width: auto;
    }
    .navbar-form .input-group > .form-control {
        width: 100%;
    }
    .navbar-form .control-label {
        margin-bottom: 0;
        vertical-align: middle;
    }
    .navbar-form .checkbox,
    .navbar-form .radio {
        display: inline-block;
        margin-top: 0;
        margin-bottom: 0;
        vertical-align: middle;
    }
    .navbar-form .checkbox label,
    .navbar-form .radio label {
        padding-left: 0;
    }
    .navbar-form .checkbox input[type="checkbox"],
    .navbar-form .radio input[type="radio"] {
        position: relative;
        margin-left: 0;
    }
    .navbar-form .has-feedback .form-control-feedback {
        top: 0;
    }
}
@media (max-width: 767px) {
    .navbar-form .form-group {
        margin-bottom: 5px;
    }
    .navbar-form .form-group:last-child {
        margin-bottom: 0;
    }
}
@media (min-width: 1200px) {
    .navbar-form {
        width: auto;
        padding-top: 0;
        padding-bottom: 0;
        margin-right: 0;
        margin-left: 0;
        border: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
}
.navbar-nav > li > .dropdown-menu {
    margin-top: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {
    margin-bottom: 0;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}
.navbar-btn {
    margin-top: 8px;
    margin-bottom: 8px;
}
.navbar-btn.btn-sm {
    margin-top: 10px;
    margin-bottom: 10px;
}
.navbar-btn.btn-xs {
    margin-top: 14px;
    margin-bottom: 14px;
}
.navbar-text {
    margin-top: 15px;
    margin-bottom: 15px;
}
@media (min-width: 1200px) {
    .navbar-text {
        float: left;
        margin-right: 15px;
        margin-left: 15px;
    }
}
@media (min-width: 1200px) {
    .navbar-left {
        float: left !important;
    }
    .navbar-right {
        float: right !important;
        margin-right: -15px;
    }
    .navbar-right ~ .navbar-right {
        margin-right: 0;
    }
}
.navbar-default {
    background-color: #f8f8f8;
    border-color: #e7e7e7;
}
.navbar-default .navbar-brand {
    color: #777;
}
.navbar-default .navbar-brand:focus,
.navbar-default .navbar-brand:hover {
    color: #5e5e5e;
    background-color: transparent;
}
.navbar-default .navbar-text {
    color: #777;
}
.navbar-default .navbar-nav > li > a {
    color: #777;
}
.navbar-default .navbar-nav > li > a:focus,
.navbar-default .navbar-nav > li > a:hover {
    color: #333;
    background-color: transparent;
}
.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:focus,
.navbar-default .navbar-nav > .active > a:hover {
    color: #555;
    background-color: #e7e7e7;
}
.navbar-default .navbar-nav > .disabled > a,
.navbar-default .navbar-nav > .disabled > a:focus,
.navbar-default .navbar-nav > .disabled > a:hover {
    color: #ccc;
    background-color: transparent;
}
.navbar-default .navbar-toggle {
    border-color: #ddd;
}
.navbar-default .navbar-toggle:focus,
.navbar-default .navbar-toggle:hover {
    background-color: #ddd;
}
.navbar-default .navbar-toggle .icon-bar {
    background-color: #888;
}
.navbar-default .navbar-collapse,
.navbar-default .navbar-form {
    border-color: #e7e7e7;
}
.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:focus,
.navbar-default .navbar-nav > .open > a:hover {
    color: #555;
    background-color: #e7e7e7;
}
@media (max-width: 767px) {
    .navbar-default .navbar-nav .open .dropdown-menu > li > a {
        color: #777;
    }
    .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus,
    .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover {
        color: #333;
        background-color: transparent;
    }
    .navbar-default .navbar-nav .open .dropdown-menu > .active > a,
    .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus,
    .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover {
        color: #555;
        background-color: #e7e7e7;
    }
    .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a,
    .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus,
    .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover {
        color: #ccc;
        background-color: transparent;
    }
}
.navbar-default .navbar-link {
    color: #777;
}
.navbar-default .navbar-link:hover {
    color: #333;
}
.navbar-default .btn-link {
    color: #777;
}
.navbar-default .btn-link:focus,
.navbar-default .btn-link:hover {
    color: #333;
}
.navbar-default .btn-link[disabled]:focus,
.navbar-default .btn-link[disabled]:hover,
fieldset[disabled] .navbar-default .btn-link:focus,
fieldset[disabled] .navbar-default .btn-link:hover {
    color: #ccc;
}
.navbar-inverse {
    background-color: #222;
    border-color: #080808;
}
.navbar-inverse .navbar-brand {
    color: #9d9d9d;
}
.navbar-inverse .navbar-brand:focus,
.navbar-inverse .navbar-brand:hover {
    color: #fff;
    background-color: transparent;
}
.navbar-inverse .navbar-text {
    color: #9d9d9d;
}
.navbar-inverse .navbar-nav > li > a {
    color: #9d9d9d;
}
.navbar-inverse .navbar-nav > li > a:focus,
.navbar-inverse .navbar-nav > li > a:hover {
    color: #fff;
    background-color: transparent;
}
.navbar-inverse .navbar-nav > .active > a,
.navbar-inverse .navbar-nav > .active > a:focus,
.navbar-inverse .navbar-nav > .active > a:hover {
    color: #fff;
    background-color: #080808;
}
.navbar-inverse .navbar-nav > .disabled > a,
.navbar-inverse .navbar-nav > .disabled > a:focus,
.navbar-inverse .navbar-nav > .disabled > a:hover {
    color: #444;
    background-color: transparent;
}
.navbar-inverse .navbar-toggle {
    border-color: #333;
}
.navbar-inverse .navbar-toggle:focus,
.navbar-inverse .navbar-toggle:hover {
    background-color: #333;
}
.navbar-inverse .navbar-toggle .icon-bar {
    background-color: #fff;
}
.navbar-inverse .navbar-collapse,
.navbar-inverse .navbar-form {
    border-color: #101010;
}
.navbar-inverse .navbar-nav > .open > a,
.navbar-inverse .navbar-nav > .open > a:focus,
.navbar-inverse .navbar-nav > .open > a:hover {
    color: #fff;
    background-color: #080808;
}
@media (max-width: 767px) {
    .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {
        border-color: #080808;
    }
    .navbar-inverse .navbar-nav .open .dropdown-menu .divider {
        background-color: #080808;
    }
    .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {
        color: #9d9d9d;
    }
    .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus,
    .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover {
        color: #fff;
        background-color: transparent;
    }
    .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a,
    .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus,
    .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover {
        color: #fff;
        background-color: #080808;
    }
    .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a,
    .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus,
    .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover {
        color: #444;
        background-color: transparent;
    }
}
.navbar-inverse .navbar-link {
    color: #9d9d9d;
}
.navbar-inverse .navbar-link:hover {
    color: #fff;
}
.navbar-inverse .btn-link {
    color: #9d9d9d;
}
.navbar-inverse .btn-link:focus,
.navbar-inverse .btn-link:hover {
    color: #fff;
}
.navbar-inverse .btn-link[disabled]:focus,
.navbar-inverse .btn-link[disabled]:hover,
fieldset[disabled] .navbar-inverse .btn-link:focus,
fieldset[disabled] .navbar-inverse .btn-link:hover {
    color: #444;
}

table {
    background-color: transparent;
}
caption {
    padding-top: 8px;
    padding-bottom: 8px;
    color: #777;
    text-align: left;
}
th {
    text-align: left;
}
.table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
}
.table > tbody > tr > td,
.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > thead > tr > th {
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #ddd;
}
.table > thead > tr > th {
    vertical-align: bottom;
    border-bottom: 2px solid #ddd;
}
.table > caption + thead > tr:first-child > td,
.table > caption + thead > tr:first-child > th,
.table > colgroup + thead > tr:first-child > td,
.table > colgroup + thead > tr:first-child > th,
.table > thead:first-child > tr:first-child > td,
.table > thead:first-child > tr:first-child > th {
    border-top: 0;
}
.table > tbody + tbody {
    border-top: 2px solid #ddd;
}
.table .table {
    background-color: #fff;
}
.table-condensed > tbody > tr > td,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > td,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > thead > tr > th {
    padding: 5px;
}
.table-bordered {
    border: 1px solid #ddd;
}
.table-bordered > tbody > tr > td,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > td,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > thead > tr > th {
    border: 1px solid #ddd;
}
.table-bordered > thead > tr > td,
.table-bordered > thead > tr > th {
    border-bottom-width: 2px;
}
.table-striped > tbody > tr:nth-of-type(odd) {
    background-color: #f9f9f9;
}
.table-hover > tbody > tr:hover {
    background-color: #f5f5f5;
}
table col[class*="col-"] {
    position: static;
    display: table-column;
    float: none;
}
table td[class*="col-"],
table th[class*="col-"] {
    position: static;
    display: table-cell;
    float: none;
}
.table > tbody > tr.active > td,
.table > tbody > tr.active > th,
.table > tbody > tr > td.active,
.table > tbody > tr > th.active,
.table > tfoot > tr.active > td,
.table > tfoot > tr.active > th,
.table > tfoot > tr > td.active,
.table > tfoot > tr > th.active,
.table > thead > tr.active > td,
.table > thead > tr.active > th,
.table > thead > tr > td.active,
.table > thead > tr > th.active {
    background-color: #f5f5f5;
}
.table-hover > tbody > tr.active:hover > td,
.table-hover > tbody > tr.active:hover > th,
.table-hover > tbody > tr:hover > .active,
.table-hover > tbody > tr > td.active:hover,
.table-hover > tbody > tr > th.active:hover {
    background-color: #e8e8e8;
}
.table > tbody > tr.success > td,
.table > tbody > tr.success > th,
.table > tbody > tr > td.success,
.table > tbody > tr > th.success,
.table > tfoot > tr.success > td,
.table > tfoot > tr.success > th,
.table > tfoot > tr > td.success,
.table > tfoot > tr > th.success,
.table > thead > tr.success > td,
.table > thead > tr.success > th,
.table > thead > tr > td.success,
.table > thead > tr > th.success {
    background-color: #dff0d8;
}
.table-hover > tbody > tr.success:hover > td,
.table-hover > tbody > tr.success:hover > th,
.table-hover > tbody > tr:hover > .success,
.table-hover > tbody > tr > td.success:hover,
.table-hover > tbody > tr > th.success:hover {
    background-color: #d0e9c6;
}
.table > tbody > tr.info > td,
.table > tbody > tr.info > th,
.table > tbody > tr > td.info,
.table > tbody > tr > th.info,
.table > tfoot > tr.info > td,
.table > tfoot > tr.info > th,
.table > tfoot > tr > td.info,
.table > tfoot > tr > th.info,
.table > thead > tr.info > td,
.table > thead > tr.info > th,
.table > thead > tr > td.info,
.table > thead > tr > th.info {
    background-color: #d9edf7;
}
.table-hover > tbody > tr.info:hover > td,
.table-hover > tbody > tr.info:hover > th,
.table-hover > tbody > tr:hover > .info,
.table-hover > tbody > tr > td.info:hover,
.table-hover > tbody > tr > th.info:hover {
    background-color: #c4e3f3;
}
.table > tbody > tr.warning > td,
.table > tbody > tr.warning > th,
.table > tbody > tr > td.warning,
.table > tbody > tr > th.warning,
.table > tfoot > tr.warning > td,
.table > tfoot > tr.warning > th,
.table > tfoot > tr > td.warning,
.table > tfoot > tr > th.warning,
.table > thead > tr.warning > td,
.table > thead > tr.warning > th,
.table > thead > tr > td.warning,
.table > thead > tr > th.warning {
    background-color: #fcf8e3;
}
.table-hover > tbody > tr.warning:hover > td,
.table-hover > tbody > tr.warning:hover > th,
.table-hover > tbody > tr:hover > .warning,
.table-hover > tbody > tr > td.warning:hover,
.table-hover > tbody > tr > th.warning:hover {
    background-color: #faf2cc;
}
.table > tbody > tr.danger > td,
.table > tbody > tr.danger > th,
.table > tbody > tr > td.danger,
.table > tbody > tr > th.danger,
.table > tfoot > tr.danger > td,
.table > tfoot > tr.danger > th,
.table > tfoot > tr > td.danger,
.table > tfoot > tr > th.danger,
.table > thead > tr.danger > td,
.table > thead > tr.danger > th,
.table > thead > tr > td.danger,
.table > thead > tr > th.danger {
    background-color: #f2dede;
}
.table-hover > tbody > tr.danger:hover > td,
.table-hover > tbody > tr.danger:hover > th,
.table-hover > tbody > tr:hover > .danger,
.table-hover > tbody > tr > td.danger:hover,
.table-hover > tbody > tr > th.danger:hover {
    background-color: #ebcccc;
}
.table-responsive {
    min-height: 0.01%;
    overflow-x: auto;
}
@media screen and (max-width: 767px) {
    .table-responsive {
        width: 100%;
        margin-bottom: 15px;
        overflow-y: hidden;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        border: 1px solid #ddd;
    }
    .table-responsive > .table {
        margin-bottom: 0;
    }
    .table-responsive > .table > tbody > tr > td,
    .table-responsive > .table > tbody > tr > th,
    .table-responsive > .table > tfoot > tr > td,
    .table-responsive > .table > tfoot > tr > th,
    .table-responsive > .table > thead > tr > td,
    .table-responsive > .table > thead > tr > th {
        white-space: nowrap;
    }
    .table-responsive > .table-bordered {
        border: 0;
    }
    .table-responsive > .table-bordered > tbody > tr > td:first-child,
    .table-responsive > .table-bordered > tbody > tr > th:first-child,
    .table-responsive > .table-bordered > tfoot > tr > td:first-child,
    .table-responsive > .table-bordered > tfoot > tr > th:first-child,
    .table-responsive > .table-bordered > thead > tr > td:first-child,
    .table-responsive > .table-bordered > thead > tr > th:first-child {
        border-left: 0;
    }
    .table-responsive > .table-bordered > tbody > tr > td:last-child,
    .table-responsive > .table-bordered > tbody > tr > th:last-child,
    .table-responsive > .table-bordered > tfoot > tr > td:last-child,
    .table-responsive > .table-bordered > tfoot > tr > th:last-child,
    .table-responsive > .table-bordered > thead > tr > td:last-child,
    .table-responsive > .table-bordered > thead > tr > th:last-child {
        border-right: 0;
    }
    .table-responsive > .table-bordered > tbody > tr:last-child > td,
    .table-responsive > .table-bordered > tbody > tr:last-child > th,
    .table-responsive > .table-bordered > tfoot > tr:last-child > td,
    .table-responsive > .table-bordered > tfoot > tr:last-child > th {
        border-bottom: 0;
    }
}

.dve-work-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, auto);
  gap: 32px;
}

@media (max-width: 992px) {
  .dve-work-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, auto);
    gap: 32px;
  }
}

@media (max-width: 768px) {
  .dve-work-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(1, auto);
    gap: 32px;
  }
}

.dve-grid-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &__body {
    width: 300px;
    height: 300px;
    position: relative;
    overflow: hidden;
  }

  &__image {
    position: relative;
    width: 100%;
    height: 100%;
    display: block;
    transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);

    img {
      height: 100%;
    }
  }

  &__caption {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease-in-out;
    background: var(--color-primary-400) !important;
    padding: 16px;
    user-select: none;
    transform: translateY(-300px);
    opacity: 0;
    transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);

    h5 {
      color: var(--primary-text-color) !important;
      font-weight: 600;
    }

    p {
      color: var(--primary-text-color-secondary) !important;
      font-weight: 500;
      font-size: 1rem;
      line-height: 1;
      padding-top: 8px;
    }
  }

  &__body:hover .dve-grid-item__image {
    opacity: 0;
    transform: translateY(300px);
  }

  &__body:hover .dve-grid-item__caption {
    transform: translateY(0);
    opacity: 1;
  }

}

.pricing-table {
  overflow-x: auto
}

.image-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(1px);
  z-index: 3;
}

.level-1-img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 1;
  z-index: 1;
  transform: translateY(0);
}

.slide-fade-enter-active {
  transition: transform 2s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-fade-leave-active {
  z-index: 2;
  transition: transform 2s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-fade-enter {
  transform: translateY(0);
}

.slide-fade-leave-to {
  transform: translateY(-100%);
}

.block-footer-1 img {
  width: 200px;
}

#contact-form-result-message {
  color: var(--color-success);

  &._error {
    color: var(--color-error);
  }
}

.edge-deployment {
  &__row {
    justify-content: center;
    gap: 2rem;
  }

  &__col {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.hero-content {
  position: relative;
  flex: 1 1 auto;
  height: 100%;
  margin: 0 40px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;

  .container-mid {
    width: fit-content;
  }
}

.image-top {
  position: absolute;
  top:10px;
}

@media (max-width: $breakpoint-sm) {
  .image-top {
    width: 116px;
  }
}

.hero-signup {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  margin: 0 40px;
  padding: 40px 0;
}

.devices-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;

  .device {
    display: flex;
    flex-direction: row;
    align-items: center;

    .device-link {
      position: relative;
      font-size: 1rem;
      font-weight: 600;
      cursor: pointer;
      @include themify() {
        color: themed('body-text-color') !important;
      }

      &:hover {
        color: var(--color-primary-200) !important;

        &.device-link::after {
          background-color: var(--color-primary-200);
        }
      }
    }

    .device-link::after {
      content: " ";
      mask: url(@/assets/img/open-in-new.svg) no-repeat 100% 100%;
      mask-size: cover;
      -webkit-mask: url(@/assets/img/open-in-new.svg) no-repeat 100% 100%;
      -webkit-mask-size: cover;
      -webkit-mask-size: cover;
      @include themify() {
        background-color: themed('body-text-color');
      }
      height: 16px;
      width: 16px;
      position: absolute;
      right: -20px;
    }

  }
}

@media (max-width: $breakpoint-md) {
  .devices-container {
    display: block;
  }
}
.icon-primary {
  color: var(--color-primary);
  margin-right: 10px;
}

.clickable-text {
  width: fit-content;
  color: var(--color-primary);
  font-weight: 600;
  font-size: 1.2rem;
  cursor: pointer;
  position: relative;

  &:hover {
    color: var(--color-primary-200);

    &.clickable-text::after {
       background-color: var(--color-primary-200);
    }
  }

}

.clickable-text::after {
  content: " ";
  mask: url(@/assets/img/arrow_right_line.svg) no-repeat 100% 100%;
  mask-size: cover;
  -webkit-mask: url(@/assets/img/arrow_right_line.svg) no-repeat 100% 100%;
  -webkit-mask-size: cover;
  -webkit-mask-size: cover;
  background-color: var(--color-primary);
  height: 22px;
  width: 22px;
  position: absolute;
  top: 5px;
  right: -25px;
}

.workflow-icon-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.active .workflow-icon-container{
  color: var(--color-primary) !important;
}

.chevron-container {
  display: flex;
  align-items: center;
}

.workflow-image {
  display: block;
  max-width:100%;
  max-height:100%;
  width: auto;
  height: auto;
}

@media (max-width: $breakpoint-sm) {
  .reverse-on-mobile {
    flex-direction: column-reverse;
  }
}

</style>
